import type { AnyRouter } from '@tanstack/react-router';

/** Router handle for non-component code (avoids importing router.tsx and its screens). */
let current: AnyRouter | null = null;
export function setAppRouter(r: AnyRouter): void {
  current = r;
}
export function navigateTo(opts: {
  to: string;
  params?: Record<string, string>;
  search?: Record<string, unknown>;
  replace?: boolean;
}): Promise<void> {
  if (!current) return Promise.resolve();
  return current.navigate(opts as never);
}
